import React, { useState } from "react";
import { Plus } from "lucide-react";
import { FONT_SIZES, FONT_FAMILY, ICON_SIZES } from "../../constants/appConfig";

const FIELD_TYPES = [
  { value: "text", label: "Text" },
  { value: "dropdown", label: "Dropdown" },
  { value: "checkbox", label: "Checkbox" },
  { value: "date", label: "Date" },
  { value: "number", label: "Number" },
];

export const CustomFieldAdder = ({
  customFields,
  setCustomFields,
  showMessage,
  palette,
}) => {
  const [newLabel, setNewLabel] = useState("");
  const [newType, setNewType] = useState("text");
  const [newOptions, setNewOptions] = useState("");
  const inputStyle = {
    padding: "8px 12px",
    borderRadius: 8,
    fontSize: FONT_SIZES.sm,
    fontFamily: FONT_FAMILY,
    border: `1px solid ${palette.inputBorder}`,
    background: palette.inputBg,
    color: palette.inputColor,
    outline: "none",
  };

  const handleAdd = () => {
    const label = newLabel.trim();
    if (!label) {
      showMessage("Field name is required", "error");
      return;
    }
    if (
      customFields.some((f) => f.label.toLowerCase() === label.toLowerCase())
    ) {
      showMessage("A field with that name already exists", "error");
      return;
    }
    const id = label
      .toLowerCase()
      .replace(/[^a-z0-9]/g, "_")
      .replace(/_+/g, "_");
    const field = { id, label, type: newType };
    if (newType === "dropdown") {
      field.options = newOptions
        .split(",")
        .map((o) => o.trim())
        .filter(Boolean);
      if (field.options.length < 2) {
        showMessage(
          "Dropdowns need at least 2 comma-separated options",
          "error"
        );
        return;
      }
    }
    setCustomFields((prev) => [...prev, field]);
    setNewLabel("");
    setNewType("text");
    setNewOptions("");
    showMessage(`"${label}" field added`);
  };

  return (
    <div
      style={{
        padding: 14,
        borderRadius: 8,
        border: `1px dashed ${palette.cardBorder}`,
        background: `${palette.accent1}04`,
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr auto",
          gap: 10,
          marginBottom: newType === "dropdown" ? 10 : 0,
        }}
      >
        <div style={{ display: "flex", gap: 10 }}>
          <input
            value={newLabel}
            onChange={(e) => setNewLabel(e.target.value)}
            placeholder="Field name..."
            style={{ ...inputStyle, flex: 1 }}
            onKeyDown={(e) => {
              if (e.key === "Enter") handleAdd();
            }}
          />
          <select
            value={newType}
            onChange={(e) => setNewType(e.target.value)}
            style={inputStyle}
          >
            {FIELD_TYPES.map((ft) => (
              <option key={ft.value} value={ft.value}>
                {ft.label}
              </option>
            ))}
          </select>
        </div>
        <button
          onClick={handleAdd}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 6,
            padding: "8px 14px",
            borderRadius: 8,
            border: "none",
            background: palette.accent1,
            color: "#fff",
            fontSize: FONT_SIZES.sm,
            fontWeight: 600,
            fontFamily: FONT_FAMILY,
            cursor: "pointer",
          }}
        >
          <Plus size={ICON_SIZES.sm} /> Add
        </button>
      </div>
      {newType === "dropdown" && (
        <input
          value={newOptions}
          onChange={(e) => setNewOptions(e.target.value)}
          placeholder="Options (comma-separated): Option A, Option B, Option C"
          style={{ ...inputStyle, width: "100%", boxSizing: "border-box" }}
        />
      )}
    </div>
  );
};
